import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "modal fade",
  id: "carModelModal",
  tabindex: "-1",
  "aria-labelledby": "confirm",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  ref: "modalRef"
}
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Car Types", -1)
const _hoisted_7 = {
  class: "btn btn-primary me-3",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  type: "button"
}
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["id", "data-id", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "ms-4 me-4 btn btn-link p-0",
      "data-bs-toggle": "modal",
      "data-bs-target": "#carModelModal",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.saveBeforeChange && $setup.saveBeforeChange(...args)))
    }, " +Add "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_7, " Save " + _toDisplayString($setup.selectedId?.length || 0) + " Type(s) Selected ", 1),
              _createElementVNode("button", {
                class: "btn btn-danger",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadSavedSelectedId && $setup.loadSavedSelectedId(...args))),
                type: "button"
              }, " Cancel ")
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Datatable, {
              ref: "tableRef",
              "table-header": $setup.tableHeader,
              "table-data": $setup.tableData,
              loading: $setup.isStoreLoading,
              total: $setup.totalStore
            }, _createSlots({
              "cell-no": _withCtx(({ index }) => [
                _createTextVNode(_toDisplayString(index +
                  1 +
                  _ctx.storeTableOption.rowsPerPage *
                    (_ctx.storeTableOption.currentPage - 1)), 1)
              ]),
              "cell-selectAction": _withCtx(({ row }) => [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `checkbox${row.id}`,
                  "data-id": `${row.id}`,
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleSelected && $setup.handleSelected(...args))),
                  checked: $setup.selectedId.includes(row.id)
                }, null, 40, _hoisted_9)
              ]),
              _: 2
            }, [
              _renderList($setup.tableHeader.filter(
                  (data) => !['selectAction', 'no'].includes(data.key)
                ), (item, i) => {
                return {
                  name: `cell-${item.key}`,
                  fn: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
                  ])
                }
              })
            ]), 1032, ["table-header", "table-data", "loading", "total"])
          ])
        ])
      ])
    ], 512)
  ]))
}